import React from "react"
// import I18n from "i18n-js/index.js.erb"
import numeral from "numeral"
import CurrencyInput from "../CurrencyInput/CurrencyInput"

class GroupContractPriceBuilder extends React.Component {

  constructor(props) {
    super(props);
    
    this.onChange = this.onChange.bind(this);
  }

  render() {
    var days_of_week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var days = days_of_week.map((day_of_week) => {
      return this.renderDayOfWeek(day_of_week);
    });
    return (
      <div className="group-contract-price">        
        <div className="row" style={{marginBottom: 20}}>
          <div className="col-md-6">
            {/* <div className="col-md-10"> */}
              <label>{I18n.t('room_type')}</label>
              <div>{this.props.room_type.name}</div>
            {/* </div> */}
          </div>
          {this.renderRemoveButton()}
        </div>

        <div className="row seven-cols">
          {days}
        </div>
      </div>
    );
  }

  renderDayOfWeek(day_of_week) {
    var name = day_of_week + '_amount';

    return (
      <div className="col" key={day_of_week}>
        <div className="form-group" style={{marginBottom: 5}}>
          <label>{I18n.t(day_of_week)}</label>
          {
            this.props.read_only 
            ?
            <div>${this.props[name] ? this.props[name] / 100 : ''}</div>
            :
            <div>
              <div className={this.renderFieldClasses(name, "input-group-currency")}>
                <CurrencyInput className="form-control" name={name} onChange={this.onChange} value={this.props[name]} onChangeEventType={true} nested={true} />
              </div>
              {this.props.room_type_price ? <div className="text-center" style={{marginTop: 5, color: '#777'}}><em>${this.props.room_type_price[name] ? numeral(this.props.room_type_price[name] / 100).format('0,0.00') : ''}</em></div> : null}
              {this.renderFieldErrors(name)}
            </div>
          }
        </div>
      </div>
    );
  }

  renderRemoveButton() {
    if (this.props.read_only != true && typeof this.props.onRemove == 'function') {
      return (
        <div className="col-md-6 col-remove flexed content-right" >
          <button type="button" className="btn btn-secondary remove-btn" onClick={this.props.onRemove.bind(this, this.props.id)}>{I18n.t('remove')}</button>
        </div>
      );
    }
      
    return null;
  }

  renderFieldClasses(field, classnames) {
    var classname = classnames || 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  } 

  renderFieldErrors(object, field) {
    if (object && object.errors && object.errors[field]) {
      var idx = 0;
      var errors = object.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }



  /**
  * Change handlers
  */
  onChange(event) {
    if (typeof this.props.onChange == 'function') {
      var group_contract_price = {
        id: this.props.id || '-0',
        group_contract: this.props.group_contract || null,
        group_contract_id: this.props.group_contract_id || (this.props.group_contract ? this.props.group_contract.id : '-0'),
        room_type: this.props.room_type || {},
        room_type_id: this.props.room_type_id || null,
        room_type_price: this.props.room_type_price || null,
        room_type_price_id: this.props.room_type_price_id || '-0',
        sunday_amount: this.props.sunday_amount || '',
        monday_amount: this.props.monday_amount || '',
        tuesday_amount: this.props.tuesday_amount || '',
        wednesday_amount: this.props.wednesday_amount || '',
        thursday_amount: this.props.thursday_amount || '',
        friday_amount: this.props.friday_amount || '',
        saturday_amount: this.props.saturday_amount || '',
      };
      group_contract_price[event.target.name] = event.target.value;
      this.props.onChange(group_contract_price);
    }
  }
};
export default GroupContractPriceBuilder
